import Image from 'next/image';
import React from 'react';

const IntegrationsTechAiSecurityGovernance = () => {
    return (
        <div className="section-py !pt-0 !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our AI Security & Governance solutions leverage a curated set of leading technologies and platforms to provide comprehensive protection, compliance, and transparency for your AI ecosystem. We architect defense-in-depth strategies using best-in-class tools that integrate seamlessly with your existing infrastructure, delivering specialized protection against evolving AI-specific threats while maintaining operational efficiency and regulatory compliance across your enterprise.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-orchestration-framework.svg"
                                width={36}
                                height={36}
                                alt="AI Security Platforms"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">AI Security Platforms</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Protect AI systems from adversarial threats and model vulnerabilities with specialized defenses. Secure with HiddenLayer, Protect AI, Robust Intelligence, CalypsoAI, and Lakera Guard for real-time threat detection.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="Data Privacy & Encryption" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Privacy & Encryption</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Safeguard sensitive data with enterprise-grade encryption and key management solutions. Encrypt with HashiCorp Vault, AWS KMS, Azure Key Vault, and Confidential Computing for regulatory compliance and data protection.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-llm-integration.svg"
                                width={36}
                                height={36}
                                alt="Access Control & Identity Management"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Access Control & Identity Management</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Enforce granular access policies with centralized identity and authentication systems. Control with Okta, Azure AD, AWS IAM, Auth0, and OAuth 2.0 for multi-factor authentication and role-based permissions.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-vector-database.svg"
                                width={36}
                                height={36}
                                alt="Monitoring & Compliance Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Monitoring & Compliance Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Automate compliance tracking and governance with continuous monitoring platforms. Monitor with Datadog Security, Splunk, OneTrust, TrustArc, and Collibra for audit automation and privacy management frameworks.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-rpa-tools.svg"
                                width={36}
                                height={36}
                                alt="Model Monitoring & Bias Detection"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Model Monitoring & Bias Detection</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Detects and mitigate model drift, bias, and fairness issues in production AI systems. Track with Fiddler AI, Arthur AI, Arize AI, WhyLabs, and Fairlearn for performance metrics and responsible AI deployment.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-minitoring-&-observation.svg"
                                width={36}
                                height={36}
                                alt="Audit & Explainability Frameworks"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Audit & Explainability Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Enhance model transparency and interpretability for regulatory compliance and trust. Explain with LIME, SHAP, InterpretML, Alibi, and MLflow Model Registry for decision traceability and audit trail documentation.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                    
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-low-code-platforms.svg" width={36} height={36} alt="Threat Detection & Defense" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Threat Detection & Defense</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Prevent prompt injection, jailbreaks, and content policy violations in LLM systems. Defend with Prompt Security, Rebuff, LLM Guard, NeMo Guardrails, and Azure Content Safety for input sanitization and filtering.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-integration-tools.svg"
                                width={36}
                                height={36}
                                alt="Vulnerability Scanning"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Vulnerability Scanning</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Identify security vulnerabilities in AI infrastructure and dependencies proactively. Scan with Snyk, Aqua Security, Trivy, OWASP Dependency-Check, and Bandit for container and code security validation.
                        </p>
                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default IntegrationsTechAiSecurityGovernance;
